<template>
  <!-- Main Wrapper -->
  <div class="main-wrapper">
    <layouts></layouts>
    <sidebar></sidebar>
    <div class="page-wrapper">
      <div class="content">
        <pageheader :title="title" :title1="title1" :loading="loading" />

        <!-- /product list -->
        <div class="card">
          <div class="card-body">
            <div class="table-top">
              <div class="card-body pb-0">
                <div class="row report-filter-row">
                  <div class="col-lg-2 col-sm-6 col-12">
                    <div class="form-group">
                      <label class="report-filter-label">Month</label>
                      <select v-model="selectedMonth" class="form-control" @change="applyMonthRange">
                        <option v-for="(month, index) in months" :key="index" :value="index + 1">
                          {{ month }}
                        </option>
                      </select>
                    </div>
                  </div>

                  <div class="col-lg-2 col-sm-6 col-12">
                    <div class="form-group">
                      <label class="report-filter-label">Year</label>
                      <select v-model="selectedYear" class="form-control" @change="applyMonthRange">
                        <option v-for="year in years" :key="year" :value="year">{{ year }}</option>
                      </select>
                    </div>
                  </div>

                  <div class="col-lg-2 col-sm-6 col-12">
                    <div class="form-group">
                      <label class="report-filter-label">Start Date</label>
                      <div class="input-groupicon">
                        <datepicker
                          v-model="startDate"
                          placeholder="Start Date"
                          class="picker"
                          :editable="true"
                          :clearable="false"
                          @update:modelValue="timeframechange"
                        />
                        <div class="addonset">
                          <img src="../../../assets/img/icons/calendars.svg" alt="img" />
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="col-lg-2 col-sm-6 col-12">
                    <div class="form-group">
                      <label class="report-filter-label">End Date</label>
                      <div class="input-groupicon">
                        <datepicker
                          v-model="endDate"
                          placeholder="End Date"
                          class="picker"
                          :editable="true"
                          :clearable="false"
                          @update:modelValue="timeframechange"
                        />
                        <div class="addonset">
                          <img src="../../../assets/img/icons/calendars.svg" alt="img" />
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- Generate Button -->
                  <div class="col-lg-2 col-sm-12 col-12">
                    <div class="form-group report-action-group">
                      <button type="button" class="btn btn-submit" :disabled="loading" @click="generateReport">
                        Generate Report
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <!-- <div class="search-set">
                <div class="search-path">
                  <a
                    class="btn btn-filter"
                    id="filter_search"
                    v-on:click="filter = !filter"
                    :class="{ setclose: filter }"
                  >
                    <img src="../../../assets/img/icons/filter.svg" alt="img" />
                    <span
                      ><img src="../../../assets/img/icons/closes.svg" alt="img"
                    /></span>
                  </a>
                </div>
                <div class="search-input">
                  <a class="btn btn-searchset"
                    ><img src="../../../assets/img/icons/search-white.svg" alt="img"
                  /></a>
                  <div id="DataTables_Table_0_filter" class="dataTables_filter">
                    <label>
                      <input
                        type="search"
                        class="form-control form-control-sm"
                        placeholder="Search..."
                        aria-controls="DataTables_Table_0"
                      />
                    </label>
                  </div>
                </div>
              </div> -->
              <div class="wordset">
                <ul>
                  <!-- <li>
                    <a data-bs-toggle="tooltip" data-bs-placement="top" title="pdf"
                      ><img src="../../../assets/img/icons/pdf.svg" alt="img"
                    /></a>
                  </li> -->
                  <li>
                     <a data-bs-toggle="tooltip" data-bs-placement="top" title="excel" @click="exportToCSV">
                       <img src="../../../assets/img/icons/excel.svg" alt="img" />
                     </a>
                  </li>
                  <!-- <li>
                    <a data-bs-toggle="tooltip" data-bs-placement="top" title="print"
                      ><img src="../../../assets/img/icons/printer.svg" alt="img"
                    /></a>
                  </li> -->
                </ul>
              </div>
            </div>
            <!-- /Filter -->
            <!-- <div
              class="card"
              id="filter_inputs"
              :style="{
                display: filter ? 'block' : 'none',
              }"
            >
              <div class="card-body pb-0">
                <div class="row">
                  <div class="col-lg-2 col-sm-6 col-12">
                    <div class="form-group">
                      <div class="input-groupicon">
                        <datepicker
                          v-model="startdate"
                          class="picker"
                          :editable="true"
                          :clearable="false"
                        />
                        <div class="addonset">
                          <img src="../../../assets/img/icons/calendars.svg" alt="img" />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-2 col-sm-6 col-12">
                    <div class="form-group">
                      <div class="input-groupicon">
                        <datepicker
                          v-model="startdate"
                          class="picker"
                          :editable="true"
                          :clearable="false"
                        />
                        <div class="addonset">
                          <img src="../../../assets/img/icons/calendars.svg" alt="img" />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-2 col-sm-6 col-12">
                    <div class="form-group">
                      <vue-select :options="Suppliers" placeholder="Choose Suppliers" />
                    </div>
                  </div>
                  <div class="col-lg-1 col-sm-6 col-12 ms-auto">
                    <div class="form-group">
                      <a class="btn btn-filters ms-auto"
                        ><img src="../../../assets/img/icons/search-whites.svg" alt="img"
                      /></a>
                    </div>
                  </div>
                </div>
              </div>
            </div> -->
            <!-- /Filter -->
            <div class="table-responsive">
              <a-table
                :columns="columns"
                :data-source="data"
              >
                <template #bodyCell="{ column, record }">
                  <template v-if="column.key === 'itemid'">
                    <div class="productimgname">
                      <!-- <a class="product-img">
                        <img
                          :src="require(`../../../assets/img/product/${record.img}`)"
                          alt="product"
                        />
                      </a> -->
                      <a href="javascript:void(0);">{{ record.categoryname }}</a>
                    </div></template
                  >
                </template>
              </a-table>
            </div>
          </div>
        </div>
        <!-- /product list -->
      </div>
    </div>
  </div>
  <searchpart></searchpart>
</template>
<script>
import { format } from "date-fns"
import axios from 'axios';

function isValidDate(date) {
  return date && !Number.isNaN(new Date(date).getTime());
}

function parseAmount(amount) {
  return parseFloat(String(amount || "").replace(/[^\d.-]/g, '')) || 0;
}

function formatCurrency(amount) {
  return new Intl.NumberFormat('en-IN', {
    style: 'currency',
    currency: 'INR',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(parseAmount(amount));
}

const columns = [
  {
    sorter: true,
  },

  {
    title: "Category Name",
    dataIndex: "categoryname",
    sorter: {
      compare: (a, b) => {
        a = a.categoryname.toLowerCase();
        b = b.categoryname.toLowerCase();
        return a > b ? -1 : b > a ? 1 : 0;
      },
    },
  },
  {
    title: "Opening Balance",
    dataIndex: "openamount",
    customRender: ({ text }) => formatCurrency(text),
    sorter: {
      compare: (a, b) => {
        return parseAmount(a.openamount) - parseAmount(b.openamount);
      },
    },
  },
  {
    title: "Purchase",
    dataIndex: "purchaseamount",
    customRender: ({ text }) => formatCurrency(text),
    sorter: {
      compare: (a, b) => {
        return parseAmount(a.purchaseamount) - parseAmount(b.purchaseamount);
      },
    },
  },
  {
    title: "Issue",
    dataIndex: "dispatchamount",
    customRender: ({ text }) => formatCurrency(text),
    sorter: {
      compare: (a, b) => {
        return parseAmount(a.dispatchamount) - parseAmount(b.dispatchamount);
      },
    },
  },
  {
    title: "Closing Balance",
    dataIndex: "closeamount",
    customRender: ({ text }) => formatCurrency(text),
    sorter: {
      compare: (a, b) => {
        return parseAmount(a.closeamount) - parseAmount(b.closeamount);
      },
    },
  },
];

export default {
  data() {
    const now = new Date();
    return {
      filter: false,
      timeframechanged: false,
      refreshTimer: null,
      reportRequestId: 0,
      loading: true,
      title: "Summary Report",
      title1: "View Summary by Category",
      selectedMonth: now.getMonth() + 1,
      selectedYear: now.getFullYear(),
      startDate: new Date(now.getFullYear(), now.getMonth(), 1),
      endDate: new Date(now.getFullYear(), now.getMonth() + 1, 0),
      months: [
        "January", "February", "March", "April", "May", "June",
        "July", "August", "September", "October", "November", "December"
      ],
      years: Array.from({ length: 5 }, (_, index) => now.getFullYear() - index),
      data: [],
      columns,
      columnTitleMap: [],
      // Suppliers: ["Choose Suppliers", "Suppliers"],
    };
  },
   methods:{
    applyMonthRange() {
      this.startDate = new Date(this.selectedYear, this.selectedMonth - 1, 1);
      this.endDate = new Date(this.selectedYear, this.selectedMonth, 0);
      this.timeframechange();
    },
    timeframechange() {
      this.timeframechanged = true;
      this.scheduleReportRefresh();
    },
    scheduleReportRefresh() {
      clearTimeout(this.refreshTimer);
      this.refreshTimer = setTimeout(() => {
        const { valid } = this.validateDateRange(false);
        if (valid) {
          this.generateReport(false);
        } else {
          this.reportRequestId += 1;
          this.data = [];
          this.loading = false;
        }
      }, 250);
    },
    getDateRange() {
      return {
        startDate: this.startDate,
        endDate: this.endDate,
      };
    },
    validateDateRange(showAlert = true) {
      const { startDate, endDate } = this.getDateRange();

      if (!isValidDate(startDate) || !isValidDate(endDate)) {
        if (showAlert) {
          window.Swal.fire("Missing dates", "Please select both start and end dates.", "warning");
        }
        return { valid: false, startDate, endDate };
      }

      if (new Date(startDate) > new Date(endDate)) {
        if (showAlert) {
          window.Swal.fire("Invalid range", "Start date cannot be after end date.", "warning");
        }
        return { valid: false, startDate, endDate };
      }

      return { valid: true, startDate, endDate };
    },
    async generateReport(showAlert = true) {
      clearTimeout(this.refreshTimer);
      const { valid, startDate, endDate } = this.validateDateRange(showAlert);

      if (!valid) {
        this.reportRequestId += 1;
        this.data = [];
        this.loading = false;
        this.timeframechanged = true;
        return;
      }

      const requestId = this.reportRequestId + 1;
      this.reportRequestId = requestId;
      this.loading = true;
      this.data = [];
      const startDateParam = format(new Date(startDate), "yyyy-MM-dd");
      const endDateParam = format(new Date(endDate), "yyyy-MM-dd");

      const apiUrl = `/v1/categoryreport?startdate=${startDateParam}&enddate=${endDateParam}`;

       try {
    const response = await axios.get(apiUrl);
    if (requestId !== this.reportRequestId) {
      return;
    }

  
    // Calculate totals
    const totals = response.data.reduce(
      (acc, item) => {
        acc.openamount += parseAmount(item.openamount);
        acc.purchaseamount += parseAmount(item.purchaseamount);
        acc.dispatchamount += parseAmount(item.dispatchamount);
        acc.closeamount += parseAmount(item.closeamount);
        return acc;
      },
      { openamount: 0, purchaseamount: 0, dispatchamount: 0, closeamount: 0 }
    );

    // Add totals row
    const totalsRow = {
    categoryname: "Total",
    openamount: totals.openamount,
    purchaseamount: totals.purchaseamount,
    dispatchamount: totals.dispatchamount,
    closeamount: totals.closeamount,
  };

    this.data = [...response.data, totalsRow];
    this.timeframechanged = false;
    this.loading = false;
  } catch (error) {
    if (requestId !== this.reportRequestId) {
      return;
    }

    console.error('Error fetching summary report', error);
    this.loading = false;
  }
    },
    generateColumnTitleMap() {
      this.columnTitleMap = this.columns.reduce((map, column) => {
        if (column.dataIndex) {
          map[column.dataIndex] = column.title || column.dataIndex;
        }
        return map;
      }, {});
    },
    async exportToCSV() {
      // Check if data is available
      if (!this.data || this.data.length === 0) {
        console.warn("No data to export.");
        return;
      }
      if (this.timeframechanged) {
        await this.generateReport().then(res => this.generateCSV());
      } else {
        this.generateCSV();
      }
    },
    generateCSV() {
      // Ensure columnTitleMap is generated
      if (Object.keys(this.columnTitleMap).length === 0) {
        this.generateColumnTitleMap();
      }

      // Map API keys to custom titles
      const mappedData = this.data.map(item => {
        const mappedItem = {};
        for (const key in item) {
          if (key in this.columnTitleMap) {
            mappedItem[this.columnTitleMap[key]] = `"${item[key]}"`;
          }
        }
        return mappedItem;
      });

      // Extract column headers and values
      const headers = Object.keys(mappedData[0]);
      const values = mappedData.map(item => headers.map(header => item[header]));

      // Create CSV content
      const csvContent =
        [headers.join(','), ...values.map(row => row.join(','))].join('\n');

      const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });

      // Generate the filename
      const { startDate, endDate } = this.getDateRange();
      const filename = `Summary_Report_${format(new Date(startDate), "yyyy-MM-dd")}_${format(new Date(endDate), "yyyy-MM-dd")}.csv`;

      // Create a download link
      const link = document.createElement('a');

      if (navigator.msSaveBlob) {
        navigator.msSaveBlob(blob, filename);
      } else {
        const url = URL.createObjectURL(blob);
        // Set link properties
        link.href = url;
        link.setAttribute('download', filename);

        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        URL.revokeObjectURL(url);
      }
  },
  },
  beforeMount() {
    this.generateReport();
  },
  beforeUnmount() {
    clearTimeout(this.refreshTimer);
  },
  name: "purchasereport",
};
</script>

<style scoped>
.report-filter-row {
  align-items: flex-end;
}

.report-filter-label {
  display: block;
  margin-bottom: 6px;
  font-size: 12px;
  font-weight: 600;
  color: #5b667a;
}

.report-action-group {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}

.picker {
  width: 100%;
}
</style>
